import {
  CardButtonSmallRounded,
  Section,
  SkeletonCardButtonSmallRounded,
  TextHeading2,
} from '@ferreri/prever-component-lib';
import { LinkWrapper } from '@ferreri/prever-component-lib/nextjs';
import { useId } from 'react';

import { useMostViewedRoutes } from './home.store';
import { StyledGroupElementScroll } from './StyledGroupElementScroll';

export const MostViewedSection = () => {
  const { items } = useMostViewedRoutes();
  const id = useId();

  return (
    <Section>
      <TextHeading2>Mais acessados</TextHeading2>
      <StyledGroupElementScroll>
        {items?.map((item, index) => {
          if (item.isLoading) {
            return <SkeletonCardButtonSmallRounded key={index} />;
          }

          return (
            <LinkWrapper href={item.link} key={`${id}-${item.label}`}>
              <CardButtonSmallRounded
                label={item.label}
                icon={<item.icon color={item.color} />}
              />
            </LinkWrapper>
          );
        })}
      </StyledGroupElementScroll>
    </Section>
  );
};
